export default function WebBrowserIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_377_38497)">
          <path
            d="M18.3346 9.99984C18.3346 14.6022 14.6037 18.3332 10.0013 18.3332M18.3346 9.99984C18.3346 5.39746 14.6037 1.6665 10.0013 1.6665M18.3346 9.99984C18.3346 8.61912 14.6037 7.49984 10.0013 7.49984C5.39893 7.49984 1.66797 8.61912 1.66797 9.99984M18.3346 9.99984C18.3346 11.3805 14.6037 12.4998 10.0013 12.4998C5.39893 12.4998 1.66797 11.3805 1.66797 9.99984M10.0013 18.3332C5.39893 18.3332 1.66797 14.6022 1.66797 9.99984M10.0013 18.3332C11.8423 18.3332 13.3346 14.6022 13.3346 9.99984C13.3346 5.39746 11.8423 1.6665 10.0013 1.6665M10.0013 18.3332C8.16035 18.3332 6.66797 14.6022 6.66797 9.99984C6.66797 5.39746 8.16035 1.6665 10.0013 1.6665M1.66797 9.99984C1.66797 5.39746 5.39893 1.6665 10.0013 1.6665"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </g>
        <defs>
          <clipPath id="clip0_377_38497">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
